import { Component, Input, OnInit } from "@angular/core";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { PowerTrainService } from "../../../app/services/powertrain.service";
import { PowertrainAnomalyStatus } from "../powertrain-modal/powertrain.model";
import { CommonModule } from "@angular/common";
import {MatButtonModule} from "@angular/material/button";
import { trigger, transition, style, animate } from '@angular/animations';
import { MatIcon } from "@angular/material/icon";
import { HttpClient } from '@angular/common/http';
import { BackendApiService } from "../../../app/services/backend-api.service";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
@Component({
  selector: "app-powertrain-anomaly-status",
  templateUrl: "./powertrain-anomaly-status.component.html",
  styleUrls: ["./powertrain-anomaly-status.component.scss"],
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIcon, MatProgressSpinnerModule],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms', style({ opacity: 0 }))
      ])
    ]),
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(50px)', opacity: 0 }),
        animate('400ms cubic-bezier(0.175, 0.885, 0.32, 1.275)',
          style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateY(50px)', opacity: 0 }))
      ])
    ]),
    trigger('bounceIn', [
      transition(':enter', [
        style({ transform: 'scale(0.3)', opacity: 0 }),
        animate('600ms cubic-bezier(0.175, 0.885, 0.32, 1.275)', style({ transform: 'scale(1)', opacity: 1 }))
      ])
    ])
  ]
})
export class PowertrainAnomalyStatusComponent implements OnInit {
  powertrainAnomalyUrl = BaseUrlConstantsService.POWERTRAIN_ANOMALY_API;
  powertrainGenerateReportUrl = BaseUrlConstantsService.POWERTRAIN_GENERATE_REPORT_API + '?reportType=onDemand';
  public report_generate = BaseUrlConstantsService.Generate_new_url;
  public production = BaseUrlConstantsService.PRODUCTION_KEY;
  public assetServiceUrl = BaseUrlConstantsService.BASE_ASSET_SERVICE;
  anomaly_status: PowertrainAnomalyStatus = {
    timeUpdatedAt: "",
    overall_status: "",
    action_required: "",
  };
  anomaly_status_loader: boolean = false;
  isReportModalOpen: boolean = false;
  isLoading: boolean = false;
  today = new Date();
  reportSize = '2.4 MB';
  currentStep = 1;
  progressPercentage = 0;
  processingStepText = 'Collecting Data';
  SAONDEMANDRESPONSE: any;
  isDownloading: boolean = false;
  public token : any = localStorage.getItem('token') || "not available";
  private processingTimers: any[] = [];
  statusClass: string = 'idle';

  @Input("asset_ids") asset_ids!: string[];
  @Input("device_ids") device_ids!: string[];
  @Input("client_id") client_id!: string;
  @Input("uuid") uuid!: string;
  @Input('overall_live_status') overall_live_status!: string;
  @Input('subsystem_id') subsystem_id!: string | number;

  constructor(private service: PowerTrainService, private http: HttpClient, private reportService: BackendApiService,) {}

  ngOnInit(): void {
    this.fetchpowertrainAnomalyStatus();
  }

  fetchpowertrainAnomalyStatus() {
    this.anomaly_status_loader = true;
    this.service
      .fetchPowertrainAnomalyStatus(
        this.powertrainAnomalyUrl +
          this.client_id +
          `?inventoryIds=${this.device_ids.join(
            ","
          )}&assetIds=${this.asset_ids.join(",")}`
      )
      .then((anomalyRes: any) => {
        this.anomaly_status = anomalyRes;
        this.getStatusClass();
        this.service.updateLastFileProcessedTime(
          this.anomaly_status.timeUpdatedAt
        );
      })
      .catch((err) => {
        this.anomaly_status = {
          timeUpdatedAt: "N/A",
          overall_status: "N/A",
          action_required: "N/A",
        };
      })
      .finally(() => {
        this.anomaly_status_loader = false;
      });
  }

  openReportModal() {
    this.isReportModalOpen = true;
    this.resetProcessing();
    this.startReportGeneration();
  }

  closeReportModal() {
    if (!this.isLoading) {
      this.isReportModalOpen = false;
      this.clearTimers();
    }
  }

  startReportGeneration() {
    // Step 1: Start with Collecting Data
    this.currentStep = 1;
    this.progressPercentage = 33;
    this.processingStepText = 'Collecting Data';

    // Step 2: After 1 second, move to Performing SA on demand
    this.processingTimers.push(setTimeout(() => {
      this.currentStep = 2;
      this.progressPercentage = 66;
      this.processingStepText = 'Performing Report Genertaion';

      // Now call the actual API
      this.callGenerateReportApi();
    }, 1000));
  }

  callGenerateReportApi() {
    const body = {
      client_id: this.client_id,
      subsystem_id: this.subsystem_id,
      subsystem_uuid: this.uuid,
    }
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `${this.token}`,
      'Timezone': localStorage.getItem('clientTimeZone') || 'not available'
    }

    this.http.post(this.powertrainGenerateReportUrl, body, {headers}).subscribe({
      next: (response: any) => {
        console.log("SA Demand API Response:", response);
        this.SAONDEMANDRESPONSE = response;

        // Step 3: After API success, show Report Generated
        this.processingTimers.push(setTimeout(() => {
          this.currentStep = 3;
          this.progressPercentage = 100;
          this.processingStepText = 'Report Generated';
          this.isLoading = false;
          this.today = new Date();
        }, 500));
      },
      error: (err) => {
        console.error("Error calling SA Demand API:", err);
        this.clearTimers();
        this.isLoading = false;
        alert("Failed to generate report. Please try again.");
      }
    });
  }

  resetProcessing() {
    this.clearTimers();
    this.currentStep = 1;
    this.progressPercentage = 33;
    this.processingStepText = 'Collecting Data';
    this.isLoading = true;
  }

  clearTimers() {
    this.processingTimers.forEach(timer => clearTimeout(timer));
    this.processingTimers = [];
  }

  downloadReport() {
    this.isDownloading = true;
    console.log('Downloading report...');
    // Implement download functionality
    let url = this.SAONDEMANDRESPONSE?.data?.assetBody?.report_url;
    console.log('Report URL:', url);
    let body: any = {
      key: url,
    };
    this.reportService
      .postAssetReport(this.assetServiceUrl + "/" + "download-report", body)
      .then((res) => {
        const responseData = JSON.parse(JSON.stringify(res)).data;
        if (responseData.status === "success") {
          const pdfFilePath = responseData.pdfFilePath;
          const link = document.createElement('a');
          link.href = pdfFilePath;
          // link.target = "_blank"; // Force the "Save As" dialog in most browsers
          document.body.appendChild(link); // Append the link to the body
          link.click(); // Trigger the download
          // setTimeout(()=>{
          //   this.paginatedReportDataArr[idx].loader=false;
          // },1800)
          document.body.removeChild(link); // Remove the link after triggering
        } else {
          // this.paginatedReportDataArr[idx].loader=false;
          // this.reportService.showError("Something went wrong");
        }
      })
      .catch(err => {
        // this.paginatedReportDataArr[idx].loader=false;
        this.reportService.showError("Something went wrong");
      })
      .finally(() => {
        this.isDownloading = false;
      });
  }

  previewReport() {
    console.log('Previewing report...');
    // Implement preview functionality
    let url = this.SAONDEMANDRESPONSE?.data?.assetBody?.report_url;
    if (!url) {
      this.reportService.showError("Report URL not available");
      return;
    }
    let body: any = {
      key: url,
    };
    this.reportService
      .postAssetReport(this.report_generate + "/" + "pre-signed-url", body)
      .then((res) => {
        if (JSON.parse(JSON.stringify(res)).status == "success") {
          if (JSON.parse(JSON.stringify(res)).body != "") {
            let report_url = JSON.parse(JSON.stringify(res)).body;
            window.open(report_url, "_blank");
          } else {
            this.reportService.showError("Something went wrong");
          }
        } else {
          this.reportService.showError("Something went wrong");
        }
      });
  }

  shareReport() {
    console.log('Sharing report...');
    // Implement share functionality
  }

  getStatusClass() {
  if (this.overall_live_status == '2') {
    this.statusClass= 'idle';
    return;
  }
  switch (this.anomaly_status?.overall_status) {
    case 'Unstatisfactory':
      this.statusClass= 'anomaly_orange';
      break;
      case 'Unacceptable':
        this.statusClass= 'anomaly_red';
        break;
        case 'Good':
          this.statusClass= 'anomaly_green';
          break;
    default:
       // or a default class
  }
}
}
